import gql from 'graphql-tag'

export default gql`
    query inspectLog($LogGroup: String!, $LogStream: String!, $Search: String!) {
        inspectLog(LogGroup: $LogGroup, LogStream: $LogStream, Search: $Search)
    }
`
